import React, { useCallback } from 'react';
import { formatISO } from 'date-fns';
import { useAppSelector } from 'store/hooks';
import { SettingsSection, Spacer, TextButtonLinkSeeAll } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { formatAmount, formatETADateForItem } from 'utils/formatting';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectFirstFivePendingActivitiesForPot } from '../reducers/selectors';
import AutosaveActivityCardForPot from './AutosaveActivityCardForPot';
import PotActivity from './PotActivity';
const PotsPendingActivitySection = ({ pot, hideSpaceUserAvatar }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const { slicedData: potsActivities, shouldShowSeeAll } = useAppSelector((state) => selectFirstFivePendingActivitiesForPot(state, pot.id));
    const handleSeeAll = useCallback(() => {
        navigateDeprecated('PotsActivity', { pot, hideSpaceUserAvatar });
    }, [hideSpaceUserAvatar, pot]);
    if (!potsActivities.length)
        return null;
    return (<>
      {!pot.deletedAt ? <Spacer h={8}/> : null}
      <SectionHeader horizontalMargins button={shouldShowSeeAll ? <TextButtonLinkSeeAll onPress={handleSeeAll}/> : null}>
        Pending
      </SectionHeader>
      <Spacer.H16 />
      <SettingsSection noMarginTop>
        {potsActivities.map((activity) => {
            if (activity.type === 'AUTO_SAVE') {
                return <AutosaveActivityCardForPot pot={pot} activity={activity} key={activity.id}/>;
            }
            const dateToUse = activity.eta || activity.depositEta;
            return (<PotActivity key={activity.id} eta={activity.eta} type={activity.type} title={activity.title} emoji={activity.emoji} amount={activity.amount} status={activity.status} timestamp={activity.timestamp} depositEta={activity.depositEta} productId={activity.potProductId} bankName={activity.potPartnerBankName} depositDetails={activity.depositDetails} isBankTransfer={activity.isBankTransfer} forceShowPositiveAmount={activity.amount.value > 0} formattedDate={dateToUse ? formatETADateForItem(formatISO(dateToUse)) : ''} formattedAmount={`${activity.amount.value > 0 ? '+' : ''}${formatAmount(activity.amount.value, activity.amount.currency, 2)}`} hideSpaceUserAvatar={hideSpaceUserAvatar} pot={pot}/>);
        })}
      </SettingsSection>
      <Spacer.H16 />
    </>);
};
export default PotsPendingActivitySection;
